import {
  establishSecureChannel,
  type SecureChannelFailure,
  type SecureInputsHandshakeError,
} from "@highnoteplatform/types";

import { iframeOrigin, packageName, packageVersion } from "./config";

const FAILURE_MESSAGES: Record<SecureChannelFailure, string> = {
  FRAME_UNREACHABLE:
    "Unable to reach the secure inputs frame. Please try again or contact support.",
  HANDSHAKE_TIMEOUT:
    "Secure inputs frame did not respond. Please try again or contact support.",
};

interface EstablishSecureInputsChannelConfig {
  frame: HTMLIFrameElement;
  uuid: string;
  clientToken: string;
  paymentCardId?: string;
  onError: (error: SecureInputsHandshakeError) => void;
  onHandshakeAck?: () => void;
}

// Secure-inputs facade over the shared secure-channel machinery: delivers
// the client token (and, for the pin frame, the payment card id) over a
// private MessagePort after frame load, mapping failures to the public
// SecureInputsHandshakeError wording.
export const establishSecureInputsChannel = ({
  frame,
  uuid,
  clientToken,
  paymentCardId,
  onError,
  onHandshakeAck,
}: Readonly<EstablishSecureInputsChannelConfig>): (() => void) =>
  establishSecureChannel({
    frame,
    iframeOrigin,
    uuid,
    clientToken,
    paymentCardId,
    sdkName: packageName,
    sdkVersion: packageVersion,
    onHandshakeAck,

    onFailure: (failure) => {
      onError({
        name: "SecureInputsHandshakeError",
        message: FAILURE_MESSAGES[failure],
      });
    },
  });
